module.exports = __webpack_public_path__ + "img/i_my_menu_03.ebc4174d.svg";